module.exports = __webpack_public_path__ + "static/media/flash-3.63204322.mp3";